module.exports = __webpack_public_path__ + "img/6.e2c8db5a.jpg";